/* FairTale GHANA: Share Love loendur.

   Naitab AINULT makstud kingitusi.
   Ostukorvi pandud toode siia ei loe: korv ei ole makstud ost.

   Number tuleb laoseisust. Shopify vahendab laoseisu siis, kui tellimus
   tekib, ehk kui makstud on. Kogutud = 0 miinus laoseis.

   Skripti ainus too on kaitsta vananenud vahemalu eest: leht voib tulla
   Shopify puhvrist vana numbriga, seega kusime paris numbri uuesti.
   Sama juhtub siis, kui ostja tuleb kassast lehele tagasi. */
(function () {
  function handleFromPath() {
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }

  function update() {
    var list = document.querySelectorAll('[data-ft-sharelove]');
    if (!list.length) return;
    var handle = handleFromPath();
    if (!handle) return;

    fetch('/products/' + handle + '.js', {
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    })
      .then(function (r) { return r.json(); })
      .then(function (product) {
        Array.prototype.forEach.call(list, function (el) {
          var vid = String(el.getAttribute('data-ft-variant'));
          var variant = null;
          (product.variants || []).forEach(function (v) {
            if (String(v.id) === vid) variant = v;
          });
          if (!variant || typeof variant.inventory_quantity !== 'number') return;
          var collected = 0 - variant.inventory_quantity;
          if (collected < 0) collected = 0;
          var n = el.querySelector('.ft-sharelove__n');
          if (n) n.textContent = String(collected);
        });
      })
      .catch(function () {});
  }

  var timer;
  function soon() {
    clearTimeout(timer);
    timer = setTimeout(update, 250);
  }

  /* kassast tagasi tulles ja vahekaarti tagasi avades kusi number uuesti */
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) soon();
  });
  window.addEventListener('pageshow', soon);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }
})();
